export default __webpack_public_path__ + "static/media/CFProfil-Inspire.34da1682.jpg";